import { getActionHandler, getInitialState } from "../helpers/crudReducers";

const initialState = getInitialState("CUSTODIAL_FORM_FUNCTIONS");
const CRUD_ACTION_HANDLERS = getActionHandler("CUSTODIAL_FORM_FUNCTIONS");

export default function custodialFormFunctions(state = initialState, action) {
  const handler = CRUD_ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
